import React from 'react';
import {PropTypes} from 'prop-types';
import {PreventDOMLock, ToString} from  '../../shared/utils';
import {Link} from '../../shared/link';

export class SimpleFilterItemComponent extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);

        this.state = SimpleFilterItemComponent.getDerivedStateFromProps(props);
        this.handleClick = this.handleClick.bind(this);
        this.doToggle = this.doToggle.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const {filter, detectPattern, negativeDetectPattern} = props;

        const newState = {
            filterDetectPattern: `(?:${(detectPattern || filter)})(\:|$|\\s|,|;)`,
            negativeFilterDetectPattern: Boolean(negativeDetectPattern) ? `(?:${negativeDetectPattern})(\:|$|\\s|,|;)` : null,
        }

        const needUpdateState = 
            !Boolean(state) ||
            (newState.filterDetectPattern != state.filterDetectPattern) ||
            (newState.negativeFilterDetectPattern != state.negativeFilterDetectPattern);

        if (needUpdateState) {
            return newState;
        }

        return null;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleClick() {
        const self = this;

        PreventDOMLock(self.doToggle);
    }

    doToggle() {
        const self = this;

        if (self._isMounted) {
            const {filters, filter} = self.props;
            const {filterDetectPattern, negativeFilterDetectPattern} = self.state;

            let newFilters = ToString(filters);

            if (new RegExp(filterDetectPattern, 'gi').test(newFilters)) {
                newFilters = newFilters.replace(new RegExp(filterDetectPattern, 'gi'), '$1');
            }
            else {
                if (Boolean(negativeFilterDetectPattern)) {
                    newFilters = newFilters.replace(new RegExp(negativeFilterDetectPattern, 'gi'), '$1');
                }
                newFilters += filter;
            }

            self.props.onChange(newFilters);
        }
    }

    render() {
        const self = this;
        const {disabled, caption, filter, filters: f} = self.props;
        const {filterDetectPattern, negativeFilterDetectPattern} = self.state;

        let className = '';
        const filters = ToString(f);

        if (new RegExp(filterDetectPattern, 'gi').test(filters)) {
            className += ' font-weight-bold';
            if (Boolean(negativeFilterDetectPattern) && 
                (new RegExp(negativeFilterDetectPattern, 'gi').test(filters))) {
                className += ' text-danger';
            }
        }

        return (
            <Link 
                disabled={disabled} 
                to={self.handleClick}
            >
                <span className={className.trim()}>{caption || filter}</span>
            </Link>
        )
    }
}
SimpleFilterItemComponent.propTypes = {
    filters: PropTypes.string,
    caption: PropTypes.string,
    filter: PropTypes.string.isRequired,
    detectPattert: PropTypes.string,
    negativeDetectPattern: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}
SimpleFilterItemComponent.defaultProps = {
    disabled: false,
}